export default __webpack_public_path__ + "static/media/Artisan's Tunic.4d59f1ba.jpg";